import React, { memo } from 'react';
import { Ant } from 'common/ant';
import styles from './styles.sass';
interface OuterProps {
  /** Left-side row label content. */
  rowName: React.ReactNode;
  /** Right-side row value text. */
  rowValue: string | undefined;
}
type Props = OuterProps;
const AppInfoRowBase: React.FC<Props> = ({
  rowName,
  rowValue
}) => <Ant.Row gutter={16} data-sentry-element="unknown" data-sentry-component="AppInfoRowBase" data-sentry-source-file="index.tsx">
        <Ant.Col xs={13} sm={9} lg={5} xl={4} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
            {rowName}
        </Ant.Col>
        <Ant.Col xs={11} sm={15} lg={19} xl={20} className={styles.versionColumn} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
            <Ant.Typography.Text strong data-sentry-element="unknown" data-sentry-source-file="index.tsx">{rowValue}</Ant.Typography.Text>
        </Ant.Col>
    </Ant.Row>;

/**
 * Admin application info row.
 *
 * @param props Row label and value content.
 * @returns Application info row component.
 *
 * @example
 * <AppInfoRow rowName="Version" rowValue="1.2.3" />
 */
export const AppInfoRow = memo(AppInfoRowBase);